import { NgModule } from '@angular/core';
import { FormatDatePipe } from './transforms/format-date.pipe';
import { BooleanTraductorPipe } from './transforms/boolean-traductor.pipe';
import { CapitalizePipe } from './transforms/capitalize.pipe';
import { EllipsizePipe } from './transforms/ellipsize.pipe';
import { NamelizePipe } from './transforms/namelize.pipe';
import { NumerizePipe } from './transforms/numerize.pipe';
import { TelefonoPipe } from './transforms/telefono.pipe';
import { ZerosPipe } from './transforms/zeros.pipe';
import { BytesPipe } from './transforms/bytes.pipe';
import { InicialesPipe } from './transforms/iniciales.pipe';
import { SafeHtml } from './transforms/safeHtml.pipe';

@NgModule({
    declarations: [
        FormatDatePipe,
        BooleanTraductorPipe,
        CapitalizePipe,
        EllipsizePipe,
        NamelizePipe,
        NumerizePipe,
        TelefonoPipe,
        ZerosPipe,
        BytesPipe,
        InicialesPipe,
        SafeHtml
    ],
    imports: [
    ],
    exports: [
        FormatDatePipe,
        BooleanTraductorPipe,
        CapitalizePipe,
        EllipsizePipe,
        NamelizePipe,
        NumerizePipe,
        TelefonoPipe,
        ZerosPipe,
        BytesPipe,
        InicialesPipe,
        SafeHtml
    ],
    providers: [
        FormatDatePipe,
        BooleanTraductorPipe,
        CapitalizePipe,
        EllipsizePipe,
        NamelizePipe,
        NumerizePipe,
        TelefonoPipe,
        ZerosPipe,
        BytesPipe,
        InicialesPipe,
        SafeHtml
    ]
})
export class PipesModule { }